import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { IMG } from "@/lib/site";

const SHOTS = [
  { src: IMG.realHero, alt: "Guincho DG Guinchos transportando veículo em Jundiaí SP", span: "sm:col-span-2 sm:row-span-2" },
  { src: IMG.realBau, alt: "Caminhão da DG Guinchos transportando caminhão baú em Jundiaí" },
  { src: IMG.realNoiteRua, alt: "Atendimento noturno de guincho 24 horas da DG Guinchos em Jundiaí" },
  { src: IMG.realSprinter, alt: "DG Guinchos transportando van executiva Sprinter na região de Jundiaí" },
  { src: IMG.realGol, alt: "VW Gol sobre a plataforma do guincho DG Guinchos" },
  { src: IMG.realDuster, alt: "Renault Duster sendo rebocado pela DG Guinchos em Jundiaí" },
  { src: IMG.realMaster, alt: "Van Renault Master sobre o guincho da DG Guinchos" },
  { src: IMG.realVw, alt: "DG Guinchos rebocando VW Jetta sobre plataforma em Jundiaí" },
  { src: IMG.realSpin, alt: "Transporte de Chevrolet Spin pela DG Guinchos em Jundiaí" },
  { src: IMG.realFiesta, alt: "Ford Fiesta sobre a plataforma do guincho DG Guinchos" },
  { src: IMG.realCitroen, alt: "Citroën C3 Picasso sendo transportado pela DG Guinchos" },
];

export const Gallery = () => {
  return (
    <section className="relative py-24 md:py-32 bg-surface border-y border-white/10">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Galeria</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            DG Guinchos em Ação
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 auto-rows-[180px] sm:auto-rows-[200px] gap-3">
          {SHOTS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-sm border border-white/10 ${s.span || ""}`}
            >
              <img
                src={s.src}
                alt={s.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors" />
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-sm text-zinc-500">
          Fotos reais da frota e dos atendimentos da DG Guinchos em Jundiaí e região.
        </p>
      </div>
    </section>
  );
};
